/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowThread200ResponseDataUser
 */
export interface ShowThread200ResponseDataUser {
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseDataUser
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataUser
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataUser
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataUser
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataUser
     */
    avatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataUser
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataUser
     */
    country?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowThread200ResponseDataUser
     */
    isAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataUser
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataUser
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowThread200ResponseDataUser interface.
 */
export function instanceOfShowThread200ResponseDataUser(value: object): value is ShowThread200ResponseDataUser {
    return true;
}

export function ShowThread200ResponseDataUserFromJSON(json: any): ShowThread200ResponseDataUser {
    return ShowThread200ResponseDataUserFromJSONTyped(json, false);
}

export function ShowThread200ResponseDataUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowThread200ResponseDataUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'username': json['username'] == null ? undefined : json['username'],
        'bio': json['bio'] == null ? undefined : json['bio'],
        'avatarUrl': json['avatar_url'] == null ? undefined : json['avatar_url'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'isAdmin': json['is_admin'] == null ? undefined : json['is_admin'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowThread200ResponseDataUserToJSON(json: any): ShowThread200ResponseDataUser {
    return ShowThread200ResponseDataUserToJSONTyped(json, false);
}

export function ShowThread200ResponseDataUserToJSONTyped(value?: ShowThread200ResponseDataUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'username': value['username'],
        'bio': value['bio'],
        'avatar_url': value['avatarUrl'],
        'city': value['city'],
        'country': value['country'],
        'is_admin': value['isAdmin'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

